import { Categories } from "@/components/General/FlyoutMenu/components/category/categories";
import { Category as CategoryBase } from "@/components/General/FlyoutMenu/components/category/category";
import { Link } from "@/components/General/FlyoutMenu/components/category/components/link";
import { Links } from "@/components/General/FlyoutMenu/components/category/components/links";
import { Title } from "@/components/General/FlyoutMenu/components/category/components/title";
import { Base } from "@/components/General/FlyoutMenu/components/flyoutMenu.base";

export const Category = Object.assign(CategoryBase, {
    Title: Title,
    Links: Links,
    Link: Link
});

export const FlyoutMenu = Object.assign(Base, {
    Categories: Categories,
    Category: Category
});
